



















import Vue from 'vue';
import {Component} from "vue-property-decorator";
import FiltreC from './FiltreC';
import ListeAnnoncesC from './ListeAnnoncesC';

@Component({
    components: {
        FiltreC,
        ListeAnnoncesC
    }
})
export default class ContentAnnoncesC extends Vue {

}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentAnnoncesC.vue